import EcosystemSvg from './EcosystemSvg.jsx';

export default EcosystemSvg;